import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from 'edenred-ui';

import { IDetailDailyLimitStatement } from '@epi-models/containers/ManageBenefitGroups';
import { StyledLinkWithHref } from '@epi-shared/components/StyledLink/StyledLink.styles';

export const DetailDailyLimitStatement = ({
  benefitType
}: IDetailDailyLimitStatement) => {
  const { t } = useTranslation();

  return (
    <Box mt={5} pb={3} id="benefit-group-details-daily-limit-statement">
      <Text id="benefit-group-details-daily-limit-statement-link">
        <StyledLinkWithHref
          target="_blank"
          href={t(
            `components.manage_benefit_${benefitType}.detail_read_more_about_limits_link`
          )}
        >
          {t(
            `components.manage_benefit_${benefitType}.detail_read_more_about_limits_text`
          )}
        </StyledLinkWithHref>
      </Text>
    </Box>
  );
};
